import { IconProps } from "../../../types/style";

const CreditCard = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.4"
          d="M11 4.5V8.23C11 9.375 10.07 10.3 8.925 10.3H3.075C1.93 10.3 1 9.375 1 8.23V4.5H11Z"
          fill={color}
        />
        <path
          d="M11 3.77007V4.50007H1V3.77007C1 2.62507 1.93 1.70007 3.075 1.70007H8.925C10.07 1.70007 11 2.62507 11 3.77007Z"
          fill={color}
        />
        <path
          d="M4 8.625H3C2.795 8.625 2.625 8.455 2.625 8.25C2.625 8.045 2.795 7.875 3 7.875H4C4.205 7.875 4.375 8.045 4.375 8.25C4.375 8.455 4.205 8.625 4 8.625Z"
          fill={color}
        />
        <path
          d="M7.25 8.625H5.25C5.045 8.625 4.875 8.455 4.875 8.25C4.875 8.045 5.045 7.875 5.25 7.875H7.25C7.455 7.875 7.625 8.045 7.625 8.25C7.625 8.455 7.455 8.625 7.25 8.625Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default CreditCard;
